export const VAT_INCLUDED_HINT = 'inkl. 19 % USt'

export function shouldShowVatHint({ cents, amount, label } = {}) {
  if (cents !== null && cents !== undefined && cents !== '') {
    const numeric = Number(cents)
    return !Number.isNaN(numeric) && numeric > 0
  }

  if (amount !== null && amount !== undefined && amount !== '') {
    const numeric = Number(amount)
    return !Number.isNaN(numeric) && numeric > 0
  }

  if (!label) {
    return false
  }

  const normalized = String(label).trim().toLowerCase()
  if (!normalized || normalized === '-' || normalized.includes('inklusive')) {
    return false
  }

  return normalized.includes('€')
}
